var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intersect"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44602 24.0205C2.80658 27.3906 5.51712 30.1011 8.88558 30.4766C11.3876 30.7555 13.9565 30.995 16.5756 30.995C19.1948 30.995 21.7637 30.7555 24.2656 30.4766C27.6341 30.1011 30.3446 27.3906 30.7052 24.0205C30.9714 21.5326 31.1961 18.9784 31.1961 16.3744C31.1961 13.7704 30.9714 11.2163 30.7052 8.72842C30.3446 5.35833 27.6341 2.64778 24.2656 2.27231C21.7637 1.99343 19.1948 1.75391 16.5756 1.75391C13.9565 1.75391 11.3876 1.99343 8.88558 2.27231C5.51712 2.64778 2.80658 5.35833 2.44602 8.72841C2.17984 11.2163 1.95508 13.7704 1.95508 16.3744C1.95508 18.9784 2.17985 21.5326 2.44602 24.0205Z",
    fill: "#0F121D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44602 24.0205C2.80658 27.3906 5.51712 30.1011 8.88558 30.4766C11.3876 30.7555 13.9565 30.995 16.5756 30.995C19.1948 30.995 21.7637 30.7555 24.2656 30.4766C27.6341 30.1011 30.3446 27.3906 30.7052 24.0205C30.9714 21.5326 31.1961 18.9784 31.1961 16.3744C31.1961 13.7704 30.9714 11.2163 30.7052 8.72842C30.3446 5.35833 27.6341 2.64778 24.2656 2.27231C21.7637 1.99343 19.1948 1.75391 16.5756 1.75391C13.9565 1.75391 11.3876 1.99343 8.88558 2.27231C5.51712 2.64778 2.80658 5.35833 2.44602 8.72841C2.17984 11.2163 1.95508 13.7704 1.95508 16.3744C1.95508 18.9784 2.17985 21.5326 2.44602 24.0205Z",
    stroke: "#84C70D",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M16.5762 10.5264L16.5762 22.2228",
    stroke: "#84C70D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M22.4238 16.375L10.7274 16.375",
    stroke: "#84C70D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlus);
export default __webpack_public_path__ + "static/media/product-plus.0500c32d2e222af31cb354b25674e495.svg";
export { ForwardRef as ReactComponent };